import { $userLanguage, $userToken } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { goToShop } from '@/app/routing/events'
import { useCallback, useEffect } from 'react'
import { $transactionHistoryList, getTransactionHistoryFx } from '@/entities/payments'
import AppLoading from '@/features/loading'
import { TransactionHistoryList } from './ui'
export const TransactionHistoryView = () => {
  const userLang = useUnit($userLanguage)

  useHideNav()
  const texts = lang[userLang].pages.transactionHistory
  const userToken = useUnit($userToken)
  const history = useUnit($transactionHistoryList)
  const { classes } = useStyles()

  const handleBack = useCallback(() => {
    goToShop({ tab: 2 })
  }, [])
  useBackButton({ onBack: handleBack })

  useEffect(() => {
    if (userToken) {
      getTransactionHistoryFx({ token: userToken, page: 1, size: 30 })
    }
  }, [userToken])

  if (!history) return <AppLoading />
  return (
    <div className={classes.root}>
      <h1>{texts.heading}</h1>
      {Array.isArray(history) && history.length === 0 && (
        <span className={classes.noPurchases}>{texts.noPurchases}</span>
      )}
      {!history ? <AppLoading /> : <TransactionHistoryList history={history} />}
    </div>
  )
}
